import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShareScreen"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM12 7.08579L7.58579 11.5L9 12.9142L11 10.9142V16.5H13V10.9142L15 12.9142L16.4142 11.5L12 7.08579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareScreen;
